import { useLang } from '@/i18n';
import EfImg from 'elem/ui/ef-img';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import { FC } from 'react';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EU9');
    const cards = [
        {
            title: t('card1_title'),
            desc: t('card1_desc'),
            tip: t('card1_tip'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297588546/Tech1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724297589300/State-of-the-art%20LFP%20Tech.jpg',
        },
        {
            title: t('card2_title'),
            desc: t('card2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297589116/Tech2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724297588386/BMS.jpg',
        },
        {
            title: t('card3_title'),
            desc: t('card3_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724297588778/Tech3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724297588928/Revolutionizing%20Durable%20Construction.jpg',
        },
    ];

    return (
        <div
            id="dp3-teaser-EU9"
            className={`${css.thecomp} dp3-teaser-EU9 dp3-teaser-full  GtmModuleData-section`}
            data-section-id={'dp3-EU9'}
            data-section-title={t('title')}
        >
            <EfSpec className="spec-x" />
            <EfTitle className="big-title" hasAnimation={false}>
                {t('bigTitle')}
            </EfTitle>
            <EfSpec className="spec-x" />
            <EfTitle className="title" hasAnimation={false}>
                {t('title')}
            </EfTitle>
            <div className="cards-box">
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img">
                                <EfImg pc={card.pc} h5={card.h5} />
                            </div>
                            <div className="card-info">
                                <p className="card-title">{card.title}</p>
                                <p className="card-desc">{card.desc}</p>
                                <p className="card-tip">{card.tip}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TheComp;
